exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bg-primary-pink{background-color:#f8264d!important}.bg-primary-violet{background-color:#7a00ff!important}footer{padding:30px 0;background:#3c3c3c;border-top:10px solid #333;text-align:center}footer,footer a,footer a:hover{color:#fff}@media (max-width:768px){footer .text-left{text-align:center}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/styles/Footer.less
// module id = 313
// module chunks = 0